import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Modal, Text, Button, i18n, tokens, TranslatedSentenceWithLink } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

import * as notifier from '../../../actions/notifier.js';
import pdfReceiptImage from '../../../assets/pdf.png';

class SubmitReceiptModal extends PureComponent {
    state = {
        photo: this.props.receiptPhoto
    };

    _selectPicture = (files) => {
        const file = new File([ files[0] ], helpers.cleanFilename(files[0].path), { type: files[0].type });
        const reader = new FileReader();
        reader.readAsDataURL(file); 

        reader.onload = () => {
            this.setState({
                photo: {
                    file,
                    image: reader.result
                }
            });

            this.props.saveData({
                file,
                image: reader.result
            }, 'receiptPhoto');
        };
    };

    _next = () => {
        if (!this.state.photo) {
            this.props.dispatch(notifier.displayError({ verbiage: i18n.t(tokens.labels.claims.providePhotoReceipt) }));
            return;
        }

        this.props.next();
    };

    render() {
        const styles = {
            container: {
                display: 'flex',
                flex: 1,
                height: '100%',
                flexDirection: 'column',
                marginBottom: 5
            },
            details: {
                display: 'flex',
                flex: 1,
                overflow: 'auto',
                flexDirection: 'column',
                marginBottom: 20,
                alignItems: 'center'
            },
            image: {
                height: 300,
                width: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto'
            },
            pdf: {
                width: '25%',
                height: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };

        let isPDF = false;

        if (this.state.photo && this.state.photo.image) {
            if (this.state.photo.file.type === 'application/pdf') {
                isPDF = true;
            }
        }

        return (
            <Modal
                testid="submit-receipt-modal"
                aria-labelledby="Submit receipt"
                open={true}
                onClose={ this.props.onClose }
                title={this.props.title}
                onBack={ this.props.onBack }
                loader={ this.props.loader }
                primaryButton={{
                    label: i18n.t(tokens.buttons.next),
                    onClick: this._next
                }}
            >
                <Text light mediumLarge margin="10px 0 20px 0">
                    {
                        this.props.type === 'HealthSpending' ?
                            i18n.t(tokens.labels.claims.provideHealthReceipt)
                            :
                            i18n.t(tokens.labels.claims.provideReceipt)
                    }
                </Text>

                {
                    this.state.photo && this.state.photo.image && isPDF &&
                            <img alt="Receipt" src={ pdfReceiptImage } style={ styles.pdf } />
                }

                {
                    this.state.photo && this.state.photo.image && !isPDF &&
                            <img alt="Receipt" src={this.state.photo.image} style={ styles.image } />
                }

                <Dropzone
                    onDrop={(files) => this._selectPicture(files)}
                    accept={{ 
                        "image/png": [ ".png" ],
                        "image/jpeg": [ ".jpeg" ],
                        "image/jpg": [ ".jpg" ],
                        "application/pdf": [ ".pdf" ] 
                    }}
                >
                    {({ getRootProps, getInputProps }) => (
                        <section>
                            <div id="dropzone" {...getRootProps()}>
                                <input {...getInputProps()} />
                                <Button
                                    marginTop={ 2 }
                                    marginBottom={ 2 }
                                    fullWidth
                                    transparent
                                >
                                    { i18n.t(tokens.buttons['select receipt']) }
                                </Button>
                            </div>
                        </section>
                    )}
                </Dropzone>

                <TranslatedSentenceWithLink
                    token={ tokens.labels.claims.claimAgreementCheckbox }
                    onClick={ this.props.openTerms }
                    linkTextColor={ this.props.whitelabel?.primaryColor }
                />
            </Modal>
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    whitelabel: state.whitelabel
});

export default connect(mapStateToProps)(SubmitReceiptModal);